import { GrupoImpuestoReadingDtoProps } from "./DTOs/GrupoImpuestoReadingDto"

export function getGrupoImpuestoAdapter(
  grupoImpuesto: GrupoImpuestoReadingDtoProps
): GrupoImpuestoReadingDtoProps {
  return {
    id: grupoImpuesto.id,
    categoria: grupoImpuesto.categoria,
    descripcion: grupoImpuesto.descripcion,
    tipoGrupoImpuesto: grupoImpuesto.tipoGrupoImpuesto,
  }
}
